/*
 * @Description: 视频列表详情
 * @Author: liuzhezhe
 * @Date: 2023-03-06 16:21:21
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-08-04 15:03:53
 */
import React, { useState, useEffect } from 'react'
import styles from './index.scss'
import { useParams } from 'react-router-dom'
import videoImg from '../../../common/images/video/video-img.png'
import axios from 'axios'
import DetailScreen from './DetailScreen/index'

const VideoDetail = (props) => {
  const params = useParams()
  const [detail, setDetail] = useState({})
  const [tableData, setData] = useState([])
  // const mid = '398300398'
  const mid = '3493296187902689'
  const series_id = params.id
  const getParticularsList = (aid) => {
    axios({
      method: 'GET',
      url: 'x/series/archives',
      params: {
        mid,
        series_id,
        only_normal: true,
        sort: 'desc',
        pn: 1,
        ps: 12
      }
    }).then(res => {
      const data = res.data.data.archives
      data.forEach(val => {
        const date = new Date(val.ctime * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        const Y = date.getFullYear() + '年'
        const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
        const D = date.getDate() + '日'
        val.ctime = Y + M + D
      })
      const obj = data.find(val => val.aid === parseInt(aid))
      if (obj) {
        setDetail(obj)
      }
      const list = data.filter(val => val.aid !== parseInt(aid))
      const list_data = list.filter((val, index) => index < 6)
      setData(list_data)
    }).catch(err => {
      console.log(err, 'err')
      setDetail({})
      setData([])
    })
  }
  const getAid = (aid) => {
    getParticularsList(aid)
  }
  useEffect(() => {
    getParticularsList(params.aid)
  }, [])

  return (
    <div className={styles['video-detail']}>
      <div className={styles['head-img']}>
        <img src={videoImg} alt='videoImg'/>
      </div>
      <div className={styles['content']}>
        <h2>{detail.title}</h2>
        <div className={styles['detail']}>
          { detail.aid && detail.bvid ? <div className={styles['detail-left']}>
            <iframe className={styles['video-iframe']} title='bilibili' src={'//player.bilibili.com/player.html?aid=' + detail.aid + '&bvid=' + detail.bvid + '&page=1&high_quality=1'} scrolling='no' border='0' frameorder='0' framespacing='0' allowFullScreen={true} />
            <p className={styles['maxLine']}>{detail.title}</p>
            <span className={styles['time']}>{detail.ctime}</span>
          </div> : ''
          }
          {
            tableData && tableData.length > 0 ? <div className={styles['detail-right']}>
              <div className={styles['recommend']}>相关推荐</div>
              <ul className={styles['detail-list']}>
                {
                  tableData.map(item => {
                    return <li onClick={() => getAid(item.aid)} key={item.aid}>
                      <div className={styles['list-img']}>
                        <img src={item.pic} alt={item.title} />
                      </div>
                      <div className={styles['list-content']}>
                        <p className={styles['maxLine']}>{item.title}</p>
                        <span className={styles['time']}>{item.ctime}</span>
                      </div>
                    </li>
                  })
                }
              </ul>
            </div> : <DetailScreen />
          }
        </div>
      </div>
    </div>
  )
}

export default VideoDetail
